import FooterRepresentation from './FooterRepresentation';

const Footer = () => <FooterRepresentation />;

export default Footer;
